import { Button } from '@material-ui/core/';
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { WithStyles } from 'decorators/withStyles';
import { IProduct } from 'interfaces/product';
import React, { Component, Fragment } from 'react';
import authService from 'services/auth';
import { productService } from 'services/productService';

interface IState {
  value: number;
  products: Array<IProduct>;
  withoutProduct: boolean;
  filteredProducts: string;
}

interface IProps {
  classes?: any;
  title?: string;
  information?: string;
  componentRender?: any;
  canAffiliateAccess?: boolean;
  hasAppBar?: boolean;
  textButton?: string;
  isTheme?: boolean;
  onClickButton?: () => void;
}

@WithStyles(theme => ({
  tabPaper: {
    borderBottom: 'solid 1px #ccc'
  },
  tabs: {
    flexGrow: 1,
    backgroundColor: '#FFF',
    border: '0 0 1px 0 #ccc',
    '& button': { minHeight: 60 }
  },
  tabLabel: {
    color: '#192542',
    textTransform: 'capitalize',
    fontSize: '1rem',
    fontWeight: 'bold'
  },
  indicatorColor: {
    backgroundColor: '#FABB0A'
  },
  containerPaper: {
    fontFamily: 'Lato',
    padding: '24px'
  },
  subTitle: {
    fontSize: '1rem',
    color: '#596375'
  },
  tab: {
    marginTop: '24px'
  },
  noPadding: {
    padding: 0
  },
  filterTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    '@media screen and (max-width: 600px)': {
      flexDirection: 'column'
    }
  },
  filter: {
    '@media screen and (max-width: 600px)': {
      margin: '24px 0 0 0'
    }
  },
  information: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: 24
  },
  informationContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  titleInformation: {
    display: 'flex',
    flexDirection: 'column'
  },
  title: {
    fontSize: '2rem',
    lineHeight: 1,
    color: theme.variables.colors['primaryColor'],
    textTransform: 'capitalize'
  },
  text: {
    marginTop: 24,
    color: '#666666'
  },
  button: {
    backgroundColor: '#009358',
    color: '#fff',
    padding: '0 20px',
    height: '40px'
  }
}))
export default class ContentDefault extends Component<IProps, IState> {
  constructor(props: {}) {
    super(props);
    this.state = { value: 0, products: null, withoutProduct: false, filteredProducts: '' };
  }

  handleChange = (event: any, value: number) => {
    productService.setProducts(null);
    authService.setTypeUser(value);
  };

  componentDidMount() {
    authService.setTypeUser(0);
  }

  render() {
    const { value } = this.state;
    const { classes, componentRender, title, canAffiliateAccess, information, textButton, onClickButton } = this.props;
    return (
      <Fragment>
        <div className={classes.information}>
          <div className={classes.informationContainer}>
            <div className={classes.titleInformation}>
              <div className={classes.title}>{title}</div>
              <div className={classes.text}>{information}</div>
            </div>
          </div>
          {!!textButton && (
            <Button className={classes.button} onClick={onClickButton}>
              {textButton}
            </Button>
          )}
        </div>
        <div>
          {!!this.props.hasAppBar && (
            <AppBar position="static" elevation={0} classes={{ root: classes.tabPaper }}>
              <Tabs
                classes={{ root: classes.tabs, indicator: classes.indicatorColor }}
                value={value}
                onChange={this.handleChange}
              >
                {canAffiliateAccess && <Tab classes={{ label: classes.tabLabel }} label="Minhas Afiliações" />}
              </Tabs>
            </AppBar>
          )}
          {componentRender}
        </div>
      </Fragment>
    );
  }
}
